import { createVNode as n, mergeProps as s } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/JsonTwoTone.js";
import a from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(a, s(t, {
    icon: m
  }), null);
};
o.displayName = "JsonTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
